import React from 'react';
import useTrans from "components/hooks/useTrans";
import { Plan } from "components/pricing/calculator/Calculator_v2";
import SwitchContainer from "components/pricing/calculator/SwitchContainer";
import SwitchOption from "components/pricing/calculator/SwitchOption";

type Props = {
    plans?: Plan[],
    selectedPlan?: any,
    setSelectedPlan?: (selectedPlan: any) => void;
};

export default function SelectPlan(props: Props) {
    const { plans, selectedPlan, setSelectedPlan } = props;
    const { t } = useTrans();

    return (
        <div>
            {plans && (
                <SwitchContainer
                    numberOfChildren={plans.length}
                    selectedIndex={plans.findIndex((p) => selectedPlan.id == p.id)}
                >
                    {plans.map((plan: any) => (
                        <SwitchOption
                            key={"select-plan__" + plan.id}
                            isSelected={selectedPlan.id == plan.id}
                            onClick={() => setSelectedPlan(plan)}
                            numberOfChildren={3}
                            className={"text-base"}
                        >
                            {plan.id}
                        </SwitchOption>
                    ))}
                </SwitchContainer>
            )}
        </div>
    );
}